import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { Playbook } from "../types/playbooks.types";

import { playbooksQueryKeys } from "./queryKeyFactory";

type UsePlaybooksListQueryParams = {
    enabled?: boolean;
};

export const usePlaybooksListQuery = ({ enabled = true }: UsePlaybooksListQueryParams = {}) => {
    return useQuery<Playbook[]>({
        queryKey: playbooksQueryKeys.all(),
        queryFn: () => salesApiService.playbooks.fetchPlaybooks(),
        enabled,
    });
};
